<template>
  <vs-card>
    <div class="vx-row pt-5 px-5">
      <div class="vx-col w-full px-8">
        <form method="POST" @submit.prevent="save_changes">
          <!-- Day -->
          <div class="vx-col w-1/2 mb-2">
            <vs-input type="number" placeholder="Enter days" class="w-full" v-validate="'required|integer'" v-model="form.days" label="Days *" name="days" data-vv-as="Days" id="days" />
            <span class="text-danger text-sm" v-show="errors.has('days')">{{ errors.first('days') }}</span>
          </div>
          <div class="vx-col w-1/2 mb-2">
            <label class="vs-input--label">Date Range *</label>
            <flat-pickr v-model="form.dateRange" v-validate="'required'" :config="datePickerConfig" placeholder="Select Date" name="dateRange" class="w-full" id="dateRange" />
            <span class="text-danger text-sm" v-show="errors.has('dateRange')">{{ errors.first('dateRange') }}</span>
          </div>
          <!-- Solo Reading -->
          <div class="vx-col w-2/12 mb-2">
            <label class="vs-input--label">Is Active</label>
            <vs-switch icon-pack="feather" class="mt-2" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" v-model="form.is_active">
              <span slot="on"></span>
              <span slot="off"></span>
            </vs-switch>
          </div>
          <!-- Save & Reset Button -->
          <div class="vx-row p-5">
            <vs-button class="mr-2 vs-con-loading__container" id="create-premium-offer" @click="save_changes"> {{ 'Update' }}</vs-button>
          </div>
        </form>
      </div>
    </div>
  </vs-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import 'flatpickr/dist/flatpickr.css'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  /** Page Name */
  name: 'AddUpdate',

  components: { flatPickr },

  /** data */
  data() {
    return {
      breadcrumb: [],
      datePickerConfig: {
        mode: 'range', // Enables date range selection
        dateFormat: 'd-m-Y'
      },
      form: {
        days: 1,
        dateRange: null,
        is_active: false
      }
    }
  },

  /** computed */
  computed: {
    ...mapState('premiumOffer', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    }
  },

  /** created */
  async created() {
    await this.$store
      .dispatch('premiumOffer/show')
      .then(async (res) => {
        const data = res.data.data
        /** breadcrumb implement  */
        if (data) {
          this.breadcrumb = [
            { title: 'Dashboard', url: '/dashboard' },
            { title: 'Premium Offer', url: '/premium-offer/add' },
            { title: `Edit Premium Offer`, active: true }
          ]
          /* form variable */
          this.form.days = data.days
          this.form.is_active = data.is_active

          // Set dateRange from API response
          const startDate = moment(data.start_date).format('DD-MM-YYYY')
          const endDate = moment(data.end_date).format('DD-MM-YYYY')
          this.form.dateRange = `${startDate} to ${endDate}`
        }
      })
      .catch((e) => {
        console.error(e)
      })
  },

  /** methods */
  methods: {
    ...mapActions('premiumOffer', {
      update: 'update'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        const dateRangeArray = this.form.dateRange.split(' to ')

        // Adjust parsing to match the new format 'DD-MM-YYYY'
        const startDate = moment(dateRangeArray[0], 'DD-MM-YYYY').startOf('day').utc() // Set to start of day in UTC
        const endDate = dateRangeArray[1]
          ? moment(dateRangeArray[1], 'DD-MM-YYYY').endOf('day').utc() // Set to end of day in UTC
          : moment(dateRangeArray[0], 'DD-MM-YYYY').endOf('day').utc()

        const data = {
          start_date: startDate.toISOString(),
          end_date: endDate.toISOString(),
          days: this.form.days,
          is_active: this.form.is_active
        }
        const response = await this.update({
          // id: this.$route.params.id,
          data
        })
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    }
  },

  /** watch */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    }
  }
}
</script>
